var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"main-with-detail-container",class:{
    'two-columns': _vm.isDetailVisible && _vm.isMainVisible,
    'detail-is-on-top': _vm.isMainFullWidth
  },attrs:{"dense":""}},[_c('Loader',{attrs:{"is-loading":_vm.isLoading}}),(_vm.isMainVisible)?_c('v-col',{staticClass:"column-container",attrs:{"cols":"12","md":_vm.mainCols}},[_vm._t("default")],2):_vm._e(),(_vm.isDetailVisible)?_c('v-col',{staticClass:"column-container",attrs:{"cols":"12","md":_vm.detailCols}},[(!_vm.hideDetail)?_c('router-view'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }